import React from 'react';
import { Grid, Toolbar, Typography } from '@mui/material';
import { StyledAppBar, StyledGridLinks } from 'components/organisms/MainNavbar/styles';
import { LanguageSelect } from 'components/molecules/LanguageSelect';
import { ProfileNavItem } from 'components/organisms/ProfileNavItem';
import { NavLink, useLocation } from 'react-router-dom';
import { MenuItems } from 'constants/MenuItems';

const MyNavLink = React.forwardRef<any, any>((props, ref) => {
  const { pathname } = useLocation();

  let isActiveItems = false;
  if (props?.items) {
    isActiveItems = props.items.some((item: string) => pathname.startsWith(item));
  }

  if (props?.disabled) {
    return props.children;
  }

  return (
    <NavLink
      ref={ref}
      to={props.to}
      className={({ isActive }) => `${isActive || isActiveItems ? 'active-nav-item' : ''}`}
    >
      {props.children}
    </NavLink>
  );
});

const MainNavbar = () => (
  <StyledAppBar position="static">
    <Toolbar>
      <Typography variant="h4">LOGO</Typography>
      <StyledGridLinks container spacing={2}>
        {MenuItems.map((item) => (
          <Grid item>
            <MyNavLink to={item.url} items={item?.items} disabled={item?.disabled}>
              <Typography variant="body2">{item.label}</Typography>
            </MyNavLink>
          </Grid>
        ))}
      </StyledGridLinks>
      <LanguageSelect isVisible={true} />
      <ProfileNavItem />
    </Toolbar>
  </StyledAppBar>
);

export { MainNavbar };
